/**
 * Contenedor visual compartido por el checkbox de selección y el botón de
 * favorito de la card de producto. Ambos son el MISMO control (cuadrado a la
 * altura del badge de categoría); solo cambian color de estado, ícono y
 * microinteracción. Mantener esta constante como única fuente de la forma.
 */
export const COURSE_CARD_CORNER_BASE =
  'shadow-(--shadow-md) relative inline-flex h-6 w-6 cursor-pointer items-center justify-center overflow-visible rounded-adipa-md border backdrop-blur-sm transition-[color,background-color,border-color,box-shadow] duration-300 ease-out';
